export const getConditions = (termMonths: number, statesProhibited: string[]): Array<string> => {
  const statesProhibitedText = statesProhibited?.length ? ` Not available in ${statesProhibited.join(', ')}.` : '';

  return [
    `The lease-to-own transaction is with Progressive Leasing, not the retailer and is not a loan or credit transaction.`,
    `Standard agreement offers ${termMonths}-months to ownership and could cost more than double the cash price. Select items only.${statesProhibitedText}`,
    `You will own the items after you have completed all payments.`,
    `You can save on leasing costs by using an early purchase option. To learn more you must call <a href="tel:877-751-6926">877-751-6926</a>. Retailer cannot activate early purchase options.`,
    `You can cancel your lease, without penalty. To learn more call, <a href="tel:877-751-6926">877-751-6926</a>.`,
    `Non-leasable items will be charged to your card today.`,
    `Progressive Leasing obtains information from credit bureaus. Not all applicants are approved.`,
  ];
};
